module.exports = __webpack_public_path__ + "static/media/stlList.abdef8d0.txt";